module.exports = __webpack_public_path__ + "img/icon_1_39.3c3cd6a2.png";